import { Injectable } from '@angular/core';
import { DocsCodification } from '../models/docs-codification.model';
import { Observable } from 'rxjs';
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
import { DocsCodificationInterface } from '../interfaces/docs-codification.interface';
import { BydModel } from '@sixense/byd-core-service';
import { INDEX_RULES_REGEX } from '../constants/index-rules.constant';

@Injectable({
  providedIn: 'root',
})
export class DocsCodificationService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get document codification.
   *
   * @param projectId ProjectId.
   * @returns Observable<DocsCodification>
   */
  public getDocumentCodification(projectId: number): Observable<BydModel<DocsCodification>> {
    this.path = `/v1/bimdata/projects/${projectId}/codification`;
    return this.getModels<DocsCodification>();
  }

  /**
   * Toggle document codification.
   *
   * @param projectId ProjectId.
   * @param id Codification id.
   * @param codification Updated codification.
   * @returns Observable<DocsCodification>
   */
  public updateDocumentCodification(
    projectId: number,
    id: number,
    codification: DocsCodification
  ): Observable<DocsCodification> {
    this.path = `/v1/bimdata/projects/${projectId}/codification/${id}`;
    return this.put<DocsCodification>({ body: codification });
  }

  /**
   * Create document codification.
   *
   * @param projectId ProjectId.
   * @returns Observable<DocsCodification>
   */
  public createDocumentCodification(projectId: number): Observable<DocsCodification> {
    const newCodification = new DocsCodification({
      name: 'codification',
      isEnabled: true,
      codificationFields: [],
      indexRule: INDEX_RULES_REGEX[0].label,
    });
    this.path = `/v1/bimdata/projects/${projectId}/codification`;
    return this.post<DocsCodification>({ body: newCodification });
  }

  /**
   * Create codification instance.
   *
   * @param jsonObject The json object.
   * @returns DocsCodification
   */
  public createNewInstance(jsonObject: DocsCodificationInterface): DocsCodification {
    return new DocsCodification(jsonObject);
  }
}
